export const USER_REQUEST = 'USER_REQUEST'
export const USER_ME_REQUEST = 'USER_ME_REQUEST'
export const FETCH_PCR = 'FETCH_PCR'
export const SET_PCR_USERS = 'SET_PCR_USERS'
export const SET_MY_USER = 'SET_MY_USER'
export const USER_RESET = 'USER_RESET'
